import { FC } from "react";
import cn from 'classnames';

import './styles.scss';

interface IconProps {
    img?: string;
    text?: string;
    icon?: string;
    name?: string;
    shape?: 'circle' | 'square' | 'rounded';
    size?: 'sm' | 'md' | 'lg';
    color?: string;
    background?: string;
    classes?: string;
    onClick?: () => void;
}

const Icon: FC<IconProps> = ({
img,
text,
icon,
name,
shape = 'circle',
size = 'md',
color,
background,
classes,
onClick
}) => {

    const iconClasses = cn('icon__wrapper', {
        [`icon__wrapper--${shape}`]: shape,
        [`icon__wrapper--${size}`]: size,
        [`icon__wrapper--${background}`]: background,
        'icon__wrapper--clickable': !!onClick,
        [`${classes}`]: classes
    });

    const handleClick = () => {
        if (onClick) onClick();
    }

    return (
        <div
            onClick={handleClick}
            className={iconClasses}
        >
            {img ? <img src={img} alt={name} /> : ''}
            {text ? <span className={`icon__wrapper--text-${color}`}>{text}</span> : ''}
            {icon ? <i className={`${icon} icon__wrapper--text-${color}`} /> : ''}
        </div>
    )
}

export default Icon;